import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';

var IntercomService = /** @class */ (function () {
    function IntercomService(config) {
        this.config = config;
        this.isLoaded = false;
        this.scriptLoaded = false;
        if (typeof this.config.enableJWTAuthentication === 'undefined') {
            this.config.enableJWTAuthentication = false;
        }
    }
    Object.defineProperty(IntercomService.prototype, "intercom", {
        get: function () {
            return typeof window.Intercom === 'function' ? window.Intercom : null;
        },
        enumerable: false,
        configurable: true
    });
    IntercomService.prototype.load = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isLoaded) return [3 /*break*/, 1];
                        console.warn('Intercom is already loaded.');
                        return [3 /*break*/, 5];
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (!!this.scriptLoaded) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.appendScript()];
                    case 2:
                        _a.sent();
                        this.scriptLoaded = true;
                        _a.label = 3;
                    case 3:
                        this.bootIntercom();
                        this.isLoaded = true;
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.error('Error loading Intercom:', err_1);
                        throw err_1;
                    case 5:
                        this.update(user !== null && user !== void 0 ? user : null);
                        return [2 /*return*/];
                }
            });
        });
    };
    IntercomService.prototype.appendScript = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = "https://widget.intercom.io/widget/" + _this.config.appId;
            script.onload = function () { return resolve(); };
            script.onerror = function () {
                return reject(new Error('Failed to load Intercom script.'));
            };
            document.body.appendChild(script);
        });
    };
    IntercomService.prototype.bootIntercom = function () {
        var _a, _b;
        if (this.isLoaded) {
            console.warn('Intercom is already loaded.');
            return;
        }
        this.intercom('boot', {
            app_id: this.config.appId,
            api_base: (_a = this.config.apiBase) !== null && _a !== void 0 ? _a : undefined,
            hide_default_launcher: (_b = this.config.hideDefaultLauncher) !== null && _b !== void 0 ? _b : true,
        });
    };
    IntercomService.prototype.shutdown = function () {
        this.isLoaded = false;
        this.intercom('shutdown');
    };
    IntercomService.prototype.update = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var userToken, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        userToken = void 0;
                        if (!(user && this.config.enableJWTAuthentication)) return [3 /*break*/, 2];
                        return [4 /*yield*/, magic.methods.externalServices.getIntercomToken()];
                    case 1:
                        userToken =
                            _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!this.isLoaded) {
                            console.warn('Intercom is not loaded. Cannot update user.');
                            return [2 /*return*/];
                        }
                        this.intercom('update', {
                            name: user === null || user === void 0 ? void 0 : user.firstName,
                            email: user === null || user === void 0 ? void 0 : user.email,
                            user_id: user === null || user === void 0 ? void 0 : user.userId,
                            intercom_user_jwt: userToken === null || userToken === void 0 ? void 0 : userToken.token,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        console.error('Failed to get Intercom user token:', err_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IntercomService.prototype.open = function () {
        if (!this.isLoaded) {
            this.load();
        }
        this.intercom('show');
    };
    return IntercomService;
}());

export { IntercomService };
